import { render, staticRenderFns } from "./policeType.vue?vue&type=template&id=eb936f60&scoped=true&"
import script from "./policeType.vue?vue&type=script&lang=js&"
export * from "./policeType.vue?vue&type=script&lang=js&"
import style0 from "./policeType.vue?vue&type=style&index=0&id=eb936f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb936f60",
  null
  
)

export default component.exports